module.exports = __webpack_public_path__ + "react/assets/TriggeringModal/TriggerByCodeStaticImages/mobileIOS.png";